import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';

export type InputProps = Omit<ISmartProps, 'css'>;
export const Input = React.forwardRef((props: InputProps, ref: any) => {
	const { readOnly, disabled, ...rest } = props;
	return (
		<View {...rest} ref={ref} readOnly={readOnly} disabled={readOnly && props.type == 'color' ? true : disabled} />
	);
});
